import * as React from 'react';
/**
 * Context which holds the navigation helpers of the parent navigator.
 * Navigators should use this context in their view component.
 */
const NavigationHelpersContext = /*#__PURE__*/React.createContext(undefined);
export default NavigationHelpersContext;
//# sourceMappingURL=NavigationHelpersContext.js.map